import D2C_Instance from '../Instance'

class D2C_InstanceAzure extends D2C_Instance {
  static active = false
  static objectType = 'instanceType'
  static providerType = 'Azure'
}

export default D2C_InstanceAzure
